<template>
  <div>
    <div
      v-if='disabled'
      class='circle'
      style="background: #b8b8b861; border: none"
    >
      <v-icon v-if='value' style='margin-top: -5px' size='18' color='primary'>{{ icons.mdiCheckBold }}
      </v-icon>
    </div>
    <div
      v-else
      class='circle cursor-pointer'
      :style="{background: value ? '#A100FF' : 'transparent'}"
    >
      <v-icon v-if='value' style='margin-top: -5px' size='18' color='#ffffff'>{{ icons.mdiCheckBold }}
      </v-icon>
    </div>
  </div>
</template>
<script>
import { mdiCheckBold } from '@mdi/js'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icons: {
        mdiCheckBold,
      },
    }
  },
  methods: {},
}
</script>

<style scoped>
.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #707070;
}
</style>
